import { memo } from 'react';

import type { ColumnWidth } from '@/components/ui/table/columnWidth';
import { getByPath } from '@/utils/widgets';
import type { WidgetData } from '../../widget.type';
import type { TextView } from '../text/text.view.type';
import type { LinkView } from './link.type';

type Props = {
  view: LinkView;
  data: WidgetData;
};

const LinkViewImpl = memo(({ view, data }: Props) => {
  const { path, urlPath, rootUrl, openInNewTab } = view;

  const textData = getByPath(data, path);
  const urlData = getByPath(data, urlPath || path);
  return (
    <div className="truncate">
      <a
        href={`${rootUrl}${urlData}`}
        rel="noopener noreferrer"
        target={openInNewTab ? '_blank' : undefined}
      >
        {textData}
      </a>
    </div>
  );
});

// sort defaults to text on path
const getSortConfig = (view: LinkView): TextView => ({
  type: 'text',
  path: view.path
});

// filtering defaults to text search on path
const getFilterConfig = (view: LinkView): TextView => ({
  type: 'text',
  path: view.path
});

// width defaults to 'medium'
const getDefaultWidth = (): ColumnWidth => 'medium';

// stringifies text data at path
const getStringifyFunction = (view: LinkView) => {
  const { path } = view;
  return (data: WidgetData) => getByPath(data, path);
};

export const linkViewProvider = {
  component: LinkViewImpl,
  getSortConfig,
  getFilterConfig,
  getDefaultWidth,
  getStringifyFunction
};
